export default class Chain {
  constructor(options = { list: [] }) {
    this._chainList = options.list;
  }

  next() {
    if (this._chainList.length > 0) {
      const item = this._chainList.shift();
      return item;
    }
  }

  end() {
    return this._chainList.length === 0;
  }
}
